const config = {
  master: false,
  tablet: false,
  color: "yellow",
  user: 2,
};
export default config;
